import React from 'react';
import { Toggle } from '@keen.io/ui-core';
import Label from '../Label';
import Row from '../Row';

var SettingsItem = function SettingsItem(_ref) {
  var id = _ref.id,
      label = _ref.label,
      isEnabled = _ref.isEnabled,
      _onChange = _ref.onChange;
  return React.createElement(Row, {
    "data-testid": id
  }, React.createElement(Label, null, label), React.createElement(Toggle, {
    isOn: isEnabled,
    onChange: function onChange(cardEnabled) {
      return _onChange(cardEnabled);
    }
  }));
};

export default SettingsItem;